import { useQuery } from '@tanstack/react-query';
import { useAPI } from '@nexelem/api';

export const useUsers = (enabled?: boolean) => {
  const api = useAPI();
  return useQuery({
    queryKey: ['users'],
    queryFn: () =>
      api
        .postUmUsersListFilter({
          postUmUsersListFilterRequest: {
            data: {},
          },
        })
        .then((res) => res.result.data),
    enabled,
  });
};
